<template>
  <v-dialog v-model="dialog" width="auto" persistent class="dialog-blur">
    <div
      class="bg-white onest-font max-w-[40vw] w-[30vw] min-h-[36vh] h-auto p-8 rounded-3xl flex flex-col justify-between shadow-2xl mx-auto"
    >
      <div>
        <h2 class="font-bold text-5xl text-gray-800">Importar Escopo</h2>
      </div>

      <div class="flex-1 flex flex-col mt-6">
        <p class="mb-2 font-semibold">
          Validação referente ao escopo desejado:
        </p>

        <div class="relative">
          <v-select
            v-model="validacaoSelecionada"
            label="Selecione uma validação"
            :items="validacoes"
            item-title="nome"
            item-value="id"
            return-object
            variant="solo"
            flat
            hide-details
            class="custom-select mt-2"
          ></v-select>
        </div>

        <div
          v-if="validacaoSelecionada"
          class="mt-6 p-4 bg-blue-50 border border-blue-100 rounded-lg text-blue-900 transition-all"
        >
          <p class="text-sm">
            Esta validação possui
            <strong>{{ validacaoSelecionada.funcionalidades }}</strong>
            funcionalidades cadastradas no escopo.
          </p>
        </div>

        <div class="flex justify-end gap-3 mt-auto pt-4">
          <v-btn
            @click="cancelarImportacao"
            variant="outlined"
            height="auto"
            color="primary"
            class="!px-6 !py-2.5 !font-bold !rounded-xl !transition-colors !normal-case tracking-normal"
            prepend-icon="mdi-close-circle-outline"
          >
            Cancelar
          </v-btn>
          <v-btn
            @click="importarEscopo"
            variant="flat"
            height="auto"
            color="primary"
            class="!px-6 !py-2.5 !text-white !font-bold !rounded-xl !transition-colors !normal-case tracking-normal shadow"
            prepend-icon="mdi-import"
          >
            Importar
          </v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
/**
 * @module ModalImportValidationScope
 * @desc Modal para realizar a importar o escopo de uma validação anterior
 * @vue-data {boolean} [ativo=false] - Define se o modal está ativo ou não.
 * @vue-data {object} [validacaoSelecionada=null] - Validação selecionada.
 * @vue-data {array} [validacoes=[]] - Lista de validações disponíveis.
 */
import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    idProjeto: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ['update:ativo', 'importar-dados'],
  computed: {
    dialog: {
      get() {
        return this.ativo;
      },
      set(value) {
        this.$emit('update:ativo', value);
      },
    },
  },
  data: () => ({
    validacaoSelecionada: null,
    validacoes: [],
    loadingValidacoes: false,
  }),
  watch: {
    ativo(newVal) {
      if (newVal) {
        this.fetchValidacoes();
      } else {
        this.validacaoSelecionada = null;
      }
    },
  },
  methods: {
    fetchValidacoes() {
      this.loadingValidacoes = true;
      axios
        .get(`${apiUrl}/api/v1/validacoes/importar`, {
          params: { idProjeto: this.idProjeto },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then((res) => {
          this.validacoes = res.data || [];
        })
        .catch((err) => {
          console.error('Erro ao buscar validações:', err);
          this.$toast.error('Erro ao carregar lista de validações.');
        })
        .finally(() => {
          this.loadingValidacoes = false;
        });
    },
    /**
     * @function cancelarImportacao
     * @desc Cancela a importação do escopo.
     * @fires this.$emit - Emite o evento 'update:ativo' com o valor false.
     */
    cancelarImportacao() {
      this.dialog = false;
    },
    /**
     * @function importarEscopo
     * @desc Importa o escopo selecionado.
     * @fires this.$emit - Emite o evento 'update:ativo' com o valor false.
     */
    importarEscopo() {
      if (!this.validacaoSelecionada) {
        this.$toast.warning('Por favor, selecione uma validação primeiro.');

        return;
      }
      this.$emit('importar-dados', this.validacaoSelecionada);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}

:deep(.v-overlay__scrim) {
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.3) !important;
}

.custom-select:deep(.v-field) {
  @apply !bg-gray-200 !border-2 !border-gray-200 !rounded-xl !shadow-none;
}
.custom-select:deep(.v-field--focused) {
  @apply !border-blue-500;
}
</style>
